import "../css/main.css";
import { toggleHamburger } from "./toggleHamburger";
import { accordion } from "./accordion";
import { tabMenu } from "./tabMenu";
import { initializeViewport } from "./initializeViewport";
import { initBackToTopButton } from "./backToTop";
import { smoothScrollToHash, setupAnchorLinks } from "./smoothScroll";
import { swiperArchivePickup } from "./swiperArchivePickup";
import { swiperTopClients } from "./swiperTopClients";
import { headerTypeB } from "./headerTypeB";
import { stickyCta } from "./stickyCta";
// import { initModals } from "./modal";

document.addEventListener("DOMContentLoaded", () => {
  toggleHamburger("js-hamburger", "js-spmenu", 1024);
  accordion();
  tabMenu();
  initializeViewport();
  initBackToTopButton();
  setupAnchorLinks(120);
  swiperArchivePickup();
  swiperTopClients();
  headerTypeB();
  stickyCta();
  // initModals();
});

window.addEventListener("load", () => {
  smoothScrollToHash(120);
});
